import React, { useState, useEffect } from "react";
import Moment from "moment";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import genericAction from "@Actions/generic";
import { Label } from "semantic-ui-react";
import IKModal from "@Components/IkModal";
import FilterUI from "@Components/Filter";
import { dropdownFormat } from "@Utils/formats";
import { isEmpty, map, concat, find } from "lodash";
import { contactOption, orderByOptions, orderByOptionsDetailed } from "./staticData";
import styles from "./styles.module.css";

const FilterModal = ({ onClose, dispatch, onApplyFilters, channels }) => {
	const [channelfiltersData, setChannelfiltersData] = useState([]);
	const [channelAll, setChannelAll] = useState(false);
	const [groupsAll, setGroupsAll] = useState(false);
	const [groupsData, setGroupsData] = useState([]);
	const [agentsData, setAgentsData] = useState([]);
	const [tagsData, setTagsData] = useState([]);
	const [categoriesData, setCategoriesData] = useState([]);
	const [cleaned, setCleaned] = useState(false);

	const [selectedFilterTemp, setSelectedFilterTemp] = useState("Etiquetas");
	const [tempOrderBy, setTempOrderBy] = useState("");
	const [tempOrderDirection, setTempOrderDirection] = useState("");
	const [startDate, setStartDate] = useState("");
	const [endDate, setEndDate] = useState("");
	const [contacts, setContacts] = useState({});
	const [agents, setAgents] = useState([]);
	const [tagsSelected, setTagsSelected] = useState([]);
	const [categoriesSelected, setCategoriesSelected] = useState([]);
	const [channelFilters, setChannelFilters] = useState([]);
	const [groupsfilters, setGroupsfilters] = useState([]);
	const [note, setNote] = useState("");
	const [actionsHistory, setActionsHistory] = useState([]);
	const [stateValue, setStateValue] = useState("");
	const [errors, setErrors] = useState({ platformfilters: "", selected: "" });

	const orderDirectionOptions = (find(orderByOptions, { key: "orderDirection" }) || {}).options || [];

	const options = [];

	useEffect(() => {
		(async () => {
			const [usersResponse, tagsResponse, groupResponse, categoriesResponse] = await Promise.all([
				dispatch(genericAction({ method: "get", route: "users/all" })),
				dispatch(genericAction({ method: "get", route: "tags/all" })),
				dispatch(genericAction({ method: "get", route: "groups/all" })),
				dispatch(genericAction({ method: "get", route: "category/all" })),
			]);

			const platoformsMapped = map(channels, (item) => {
				return {
					key: item.id,
					text: `${item.platform.name} - ${item.label.toLowerCase()}`,
					value: item.id,
				};
			});

			const groupsMapped = dropdownFormat(groupResponse, "name", "id");
			const agentsMapped = dropdownFormat(usersResponse, "user.fullName", "userId");
			const tagsMapped = map(tagsResponse, (item) => {
				return {
					key: item.id,
					text: item.name,
					value: item.id,
					categoryId: item.categoryId,
				};
			});
			const categoriesMapped = dropdownFormat(categoriesResponse, "name", "id");
			groupsMapped.unshift({ key: "*", text: "Sin grupo", value: "*" });

			setGroupsData(groupsMapped);
			setChannelfiltersData(platoformsMapped);
			setAgentsData(agentsMapped);
			setTagsData(tagsMapped);
			setCategoriesData(categoriesMapped);
		})();
	}, []);

	const checkAll = (name) => {
		if (name === "channelFilters") {
			if (!channelAll) {
				const allChannelIds = map(channels, (item) => {
					return item.id;
				});
				setChannelFilters(allChannelIds);
				setChannelAll(true);
			} else {
				setChannelFilters([]);
				setChannelAll(false);
			}
		} else if (name === "groupsfilters") {
			if (!groupsAll) {
				const allGroupIds = map(groupsData, (item) => {
					return item.value;
				});
				setGroupsfilters(allGroupIds);
				setGroupsAll(true);
			} else {
				setGroupsfilters([]);
				setGroupsAll(false);
			}
		}
	};

	const handleInput = (e) => {
		const { name, value } = e.target;
		if (name === "startDate") {
			setStartDate(value);
		} else {
			setEndDate(value);
		}
	};

	const getMaxDate = () => {
		return Moment().format("YYYY-MM-DD");
	};

	const handleTipyfication = (name, data) => {
		setTagsSelected(data);
	};

	const handleInputDropdown = (e, { value }) => {
		setTagsSelected(value);
	};

	const onFilter = () => {
		const contactId = contacts?.id || null;
		const errorsTest = {};

		const noFieldsSelected =
			isEmpty(agents) &&
			!contactId &&
			isEmpty(groupsfilters) &&
			isEmpty(tagsSelected) &&
			isEmpty(startDate) &&
			isEmpty(endDate) &&
			isEmpty(note) &&
			isEmpty(channelFilters) &&
			isEmpty(selectedFilterTemp) &&
			isEmpty(actionsHistory);

		if (noFieldsSelected) {
			errorsTest.selected = "Debe seleccionar mínimo un campo";
			setErrors(errorsTest);
			return;
		}

		setErrors({});
		const filters = {};

		if (contactId) filters.contactId = contactId;
		if (!isEmpty(agents)) filters["chat.userId[]"] = concat([], agents);
		if (!isEmpty(groupsfilters)) {
			if (groupsfilters.includes("*")) {
				filters["chat.groupId&*"] = 0;
			} else {
				filters["chat.groupId[]"] = concat([], groupsfilters);
			}
		}
		if (!isEmpty(tagsSelected)) filters["tagId[]"] = tagsSelected;
		if (!isEmpty(categoriesSelected)) filters["tag.categoryId[]"] = categoriesSelected;
		if (note) filters["chat.text"] = note;
		if (!isEmpty(channelFilters)) filters["chat.channelId[]"] = concat([], channelFilters);

		if (startDate) filters.createdDate = startDate;
		if (endDate) filters.closeDate = endDate;

		if (tempOrderBy) filters.orderKey = tempOrderBy;
		if (tempOrderDirection) filters.orderDir = tempOrderDirection;

		if (onApplyFilters) {
			onApplyFilters(filters);
		}
		onClose();
	};

	const cleanModal = () => {
		setAgents([]);
		setContacts("");
		setChannelFilters([]);
		setGroupsfilters([]);
		setTagsSelected([]);
		setCategoriesSelected([]);
		setStartDate("");
		setEndDate("");
		setNote("");
		setActionsHistory([]);
		setGroupsAll(false);
		setChannelAll(false);
		setCleaned(true);
		setErrors({ platformfilters: "", selected: "" });
		setTimeout(() => {
			return setCleaned(false);
		}, 2000);
	};

	const onChangeSelection = (e, { value }) => {
		setSelectedFilterTemp(value);
	};

	const handleOrderByChange = (value) => {
		setTempOrderBy(value);
	};

	const getOrderByOptions = () => {
		return orderByOptionsDetailed;
	};

	const onChangeDropdown = (value, name) => {
		if (name === "channelFilters") {
			setChannelFilters(value);
			setChannelAll(channelfiltersData.length === value.length);
		} else if (name === "groupsfilters") {
			setGroupsfilters(value);
			setGroupsAll(groupsData.length === value.length);
		}
	};

	const onContactsSelect = (item) => {
		setContacts(item);
	};

	const onContactsRemove = () => {
		setContacts({});
	};

	const renderLabelPlatforms = (label) => {
		return {
			color: "blue",
			content: `${label.text}`,
			icon: label.icon,
		};
	};

	const renderLabelDepartments = (label) => {
		return {
			color: "blue",
			content: `${label.text} `,
			icon: "building outline",
		};
	};

	const renderLabelChannels = (label) => {
		return {
			color: "blue",
			content: `${label.text}`,
			icon: label.icon,
		};
	};

	const getFieldsetClass = (filters, data) => {
		const safeFilters = filters || [];
		const safeData = data || [];
		if (isEmpty(safeFilters) && isEmpty(agents) && isEmpty(tagsSelected)) return "";
		const ratio = safeData.length === 0 ? 0 : safeFilters.length / safeData.length;
		if (ratio > 0.75 || !isEmpty(agents) || !isEmpty(tagsSelected)) return styles.hasMostOptions;
		if (ratio > 0.5) return styles.hasManyOptions;
		return styles.hasOptions;
	};

	return (
		<IKModal
			iconName="filter"
			title="Filtro de Conv. Generales"
			onClose={onClose}
			onSuccess={onFilter}
			cancelLabel="Cancelar"
			saveLabel="Filtrar"
			fullHeight
			ignoreContent
			size="small">
			<div className={styles.container}>
				{!isEmpty(errors.selected) && (
					<div className={styles.center}>
						<Label basic color="red" pointing="below" className={styles.labelError}>
							{errors.selected}
						</Label>
					</div>
				)}
				<FilterUI
					errors={errors}
					options={options}
					selectedFilterTemp={selectedFilterTemp}
					onChangeSelection={onChangeSelection}
					startDate={startDate}
					endDate={endDate}
					handleInput={handleInput}
					getMaxDate={getMaxDate}
					tempOrderBy={tempOrderBy}
					handleOrderByChange={handleOrderByChange}
					getOrderByOptions={getOrderByOptions}
					orderDirectionOptions={orderDirectionOptions}
					tempOrderDirection={tempOrderDirection}
					setTempOrderDirection={setTempOrderDirection}
					contacts={contacts}
					onContactsSelect={onContactsSelect}
					onContactsRemove={onContactsRemove}
					contactOption={contactOption}
					agents={agents}
					setAgents={setAgents}
					agentsData={agentsData}
					renderLabelPlatforms={renderLabelPlatforms}
					tagsSelected={tagsSelected}
					handleInputDropdown={handleInputDropdown}
					tagsData={tagsData}
					handleTipyfication={handleTipyfication}
					note={note}
					setNote={setNote}
					channelAll={channelAll}
					checkAll={checkAll}
					channelFilters={channelFilters}
					channelfiltersData={channelfiltersData}
					renderLabelChannels={renderLabelChannels}
					groupsData={groupsData}
					groupsAll={groupsAll}
					groupsfilters={groupsfilters}
					onChangeDropdown={onChangeDropdown}
					renderLabelDepartments={renderLabelDepartments}
					cleanModal={cleanModal}
					cleaned={cleaned}
					getFieldsetClass={getFieldsetClass}
					stateValue={stateValue}
					setStateValue={setStateValue}
					actionsHistory={actionsHistory}
					setActionsHistory={setActionsHistory}
					categoriesSelected={categoriesSelected}
					setCategoriesSelected={setCategoriesSelected}
					categoriesData={categoriesData}
				/>
			</div>
		</IKModal>
	);
};

FilterModal.propTypes = {
	onClose: PropTypes.func,
	dispatch: PropTypes.func,
	onApplyFilters: PropTypes.func,
	channels: PropTypes.array,
};

function mapStateToProps({ company }) {
	return {
		channels: company.channels,
	};
}

export default connect(mapStateToProps)(FilterModal);
